import {
  ApiOutlined,
  CloudServerOutlined,
  CodeOutlined,
  DatabaseOutlined,
  GithubOutlined,
  MailOutlined,
  MessageOutlined,
  SlackOutlined,
} from "@ant-design/icons";

type Matcher = { test: (needle: string) => boolean; icon: React.ReactNode };

const MATCHERS: Matcher[] = [
  { test: (n) => n.includes("github"), icon: <GithubOutlined /> },
  { test: (n) => n.includes("slack"), icon: <SlackOutlined /> },
  {
    test: (n) => n.includes("gmail") || n.includes("mail"),
    icon: <MailOutlined />,
  },
  {
    test: (n) =>
      n.includes("postgres") ||
      n.includes("mysql") ||
      n.includes("database") ||
      n.includes("bigquery"),
    icon: <DatabaseOutlined />,
  },
  {
    test: (n) => n.includes("mcp") || n.includes("server"),
    icon: <CloudServerOutlined />,
  },
  {
    test: (n) => n.includes("chat") || n.includes("teams"),
    icon: <MessageOutlined />,
  },
  {
    test: (n) => n.includes("code") || n.includes("repo"),
    icon: <CodeOutlined />,
  },
];

/** Picks a connector-type glyph from the display name / id. */
export const connectorIconFor = (displayName: string): React.ReactNode => {
  const needle = displayName.toLowerCase();
  for (const m of MATCHERS) if (m.test(needle)) return m.icon;
  return <ApiOutlined />;
};
